import { ToastError, ToastSuccess } from '@/utils'
import api from '@/api'

export default {
  methods: {
    favourResearchActivity ({resourceType, resourceId}) {
      let fisPersid = this.$store.getters['user/fisPersid']
      let isAuthorized = this.$store.getters['user/isAuthorized']
      if (isAuthorized) {
        if (this.isFavouredResearchActivity({resourceType, resourceId})) {
          // DELETE
          api.maco.researchSelection('delete', fisPersid, resourceType, resourceId)
          .then((data) => {
            this.$store.dispatch('aboutme/setResearchActivityAsFavourite', data)
            ToastSuccess(this.$gettext('AboutMe.toast.deselect'), 1500)
          })
          .catch(() => {
            /* error handling in api.maco */
          })
        } else {
          // POST
          api.maco.researchSelection('post', fisPersid, resourceType, resourceId)
          .then((data) => {
            this.$store.dispatch('aboutme/setResearchActivityAsFavourite', data)
            ToastSuccess(this.$gettext('AboutMe.toast.select'), 1500)
          })
          .catch((error) => {
            /* error handling in api.maco */
            ToastError(this.$gettext(error))
          })
        }
      }
    },
    isFavouredResearchActivity ({resourceType, resourceId}) {
      return this.$store.getters['aboutme/favouredResearchActivity'][resourceType].includes(Number(resourceId))
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/FavourResearchActivity.js